<template>
  <div class="l_loginbonus" :class="{ lock: this.alert }">
    <div class="container">
      <div class="content">
        <div class="ver_caution">
          ※ログインボーナス機能はアプリバージョン4.2.0以上対応です。
        </div>
        <h3>毎日アプリを立ち上げてためよう</h3>
        <hr />
        <p>
          まんぷくメーターはアプリを立ち上げると1日1回たまります。<br />
          メーターがいくつ上がるかはその日の運しだい！また、まんぷくメーターは「ジョイちゃん」のお食事にもなっています。
        </p>
        <br />
        <p>
          ※ログインボーナスを受け取る際は、お手数ですがアプリを一度閉じてから、再度立ち上げ直してください。立ち上げたままですと、起動の確認が取れず、ログインボーナスを受け取れない場合がございます。
        </p>
        <img :src="require('@/assets/img/loginbonus/logbo-faq2.png')" />
        <p>
          まんぷくメーターのメニューは、日によって変わります。ぜひ毎日アプリを開いてジョイちゃんにいろんなメニューを食べさせてあげてください。
        </p>
        <br />
        <br />

        <h3>まんぷくメーターが満タンになるとスタンプGET！</h3>
        <hr />
        <p>
          まんぷくメーターがたまると、「香の川製麺まんぷくスタンプ」がゲットできます。スタンプページを確認してください。
        </p>
        <br />
        <div class="ver_caution">
          ※ログインボーナス機能はアプリバージョン4.2.0以上対応です。
        </div>
      </div>

      <div class="l_button__external">
        <UIButton :label="'ログインボーナスを確認する'" @click="goLogbo" />
      </div>
    </div>
    <VersionCheck :show="alert" :on-close="closeAlert" :msg="errorMsg" />
  </div>
</template>

<script>
import UIButton from '@/components/UIButton'
import VersionCheck from './FAQWalkVersionCheck'

import { mapActions } from 'vuex'
import { FactoryTrack } from '@/constant/firebase'
import '@/styles/color.css'

export default {
  name: 'FAQWalk',
  components: { UIButton, VersionCheck },
  data: function() {
    return {
      alert: 0,
      errorMsg:
        'ログインボーナスはアプリバージョン4.2.0以上対応です。<br />最新版のアプリにアップデートしてください。'
    }
  },
  created() {
    document.title = 'ログインボーナスについて'
  },
  methods: {
    ...mapActions('Native', [
      'actionOpenWalk',
      'actionRequestExternalLink',
      'actionVer4_2'
    ]),
    ...mapActions('Analytics', ['trackEvent']),
    goLogbo: async function() {
      this.trackEvent(FactoryTrack.createLoginbonus())
      this.alert = await this.actionVer4_2()
      if (this.alert === 0) {
        this.$router.push({ path: '/loginbonus' })
      }
    },
    closeAlert: function() {
      this.trackEvent(FactoryTrack.createVersionCheckClose())
      this.alert = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.l_button__external {
  width: 250px;
  margin: 20px auto 0;
}

.l_loginbonus {
  color: #333333;
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
  text-align: center;
  overflow: scroll;
  &.lock {
    overflow: hidden;
  }

  .container {
    padding-bottom: 20px;
  }
  .hero {
    background: var(--background-color);
    text-align: center;
    h1 {
      color: #ed2a32;
      font-size: 7vw;
      font-weight: 900;
    }
    .subtitle {
      margin: 10px 0;
      font-size: 4vw;
    }

    .image {
      text-align: center;
      img {
        max-width: 100%;
      }
    }
    .button {
      color: #ffffff;
      font-weight: bold;
      /* background: linear-gradient(to right, #fea666, #f83746); */

      background-image: url('~@/assets/img/walk/btn-walk.png');
      background-size: cover;
      background-position: center;
      width: 80%;
      display: inline-block;
      margin: 8px 0;
      padding: 16px 0;
      border-radius: 4px;
    }

    .caution {
      text-align: center;
      margin: 0 10px;
      font-size: 4vw;
      color: #3e3e3e;
      .small {
        font-size: 3vw;
      }
    }
  }
  .content {
    background-color: #ffffff;
    text-align: left;
    padding: 0 20px;

    .ver_caution {
      font-size: 3vw;
      color: #666666;
      margin: 10px 0;
      text-align: justify;
    }

    h3,
    h4 {
      color: #602209;
      font-family: 'HiraKakuPro-W6', sans-serif;
    }
    h4 {
      margin: 10px 0px;
    }

    hr {
      margin-top: 10px;
      margin-bottom: 10px;
      border: none;
      border-bottom: 1px solid #efb90f;
    }
    img {
      margin-top: 10px;
      margin-bottom: 10px;
      max-width: 100%;
      text-align: center;
    }
    p {
      word-break: break-all;
      text-align: justify;
    }
  }
  .l_button__external {
    width: 250px;
    margin: 20px auto 0;
  }
}
</style>
